<template>
  <a-card :title="$t('label.workspace.managed.scripts')">
    <a-alert
      type="info"
      show-icon
      style="margin-bottom: 16px"
      :message="$t('message.workspace.managed.scripts')" />
    <a-form layout="vertical">
      <a-form-item v-if="isDomainAdmin" :label="$t('label.workspace.managed.inherit')">
        <a-switch v-model:checked="inherit" :disabled="!canUpdate" />
        <div class="form-help">{{ $t('message.workspace.managed.inherit') }}</div>
      </a-form-item>
      <a-form-item :label="$t('label.workspace.managed.enabled')">
        <a-switch v-model:checked="managed" :disabled="inherit || !canUpdate" />
      </a-form-item>
      <a-form-item :label="$t('label.workspace.windows.powershell.script')">
        <a-textarea v-model:value="windows" :rows="12" :disabled="inherit || !managed || !canUpdate" />
        <div class="form-help">{{ $t('message.workspace.windows.powershell.script') }}</div>
      </a-form-item>
      <a-form-item :label="$t('label.workspace.linux.shell.script')">
        <a-textarea v-model:value="linux" :rows="12" :disabled="inherit || !managed || !canUpdate" />
        <div class="form-help">{{ $t('message.workspace.linux.shell.script') }}</div>
      </a-form-item>
      <a-button type="primary" :loading="saving" :disabled="!canUpdate" @click="save">
        {{ $t('label.save') }}
      </a-button>
    </a-form>
  </a-card>
</template>

<script>
import { getAPI, postAPI } from '@/api'

export default {
  name: 'WorkspaceManagedScripts',
  props: {
    resource: { type: Object, required: false, default: null }
  },
  data () {
    return { configured: false, inherit: false, managed: false, windows: '', linux: '', saving: false }
  },
  computed: {
    canUpdate () { return 'workspaceManagedScriptsUpdate' in this.$store.getters.apis },
    domainId () { return this.resource?.id },
    isDomainAdmin () { return this.$store.getters.userInfo.roletype === 'DomainAdmin' }
  },
  created () { this.load() },
  watch: {
    domainId () { this.load() }
  },
  methods: {
    params () { return this.domainId ? { domainid: this.domainId } : {} },
    load () {
      getAPI('workspaceManagedScriptsList', this.params()).then(json => {
        const response = json.workspacemanagedscriptsresponse
        const result = response.payload || response
        this.configured = Boolean(result.configured)
        this.inherit = this.isDomainAdmin && !this.configured
        this.managed = result.managed
        this.windows = result.windows || ''
        this.linux = result.linux || ''
      })
    },
    save () {
      this.saving = true
      postAPI('workspaceManagedScriptsUpdate', {
        ...this.params(), inherit: this.inherit, managed: this.managed, windows: this.windows, linux: this.linux
      }).then(() => {
        this.$notification.success({ message: this.$t('label.success'), description: this.$t('message.workspace.managed.scripts.saved') })
        this.load()
      }).catch(error => {
        this.$notification.error({ message: this.$t('label.error'), description: error?.response?.data?.workspacemanagedscriptsresponse?.errortext || error.message })
      }).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.form-help {
  color: rgba(0, 0, 0, 0.55);
  font-size: 12px;
  margin-top: 4px;
}
</style>
